export default (router) => {
  router.beforeEach((to, from, next) => {
    if (!to.meta.allowAnonymous && !localStorage.getItem('account/token')) {
      next({
        name: 'Login',
        query: {
          redirect: to.fullPath,
        },
      });
      return;
    }

    next();
  });
};
